import request from '@/http/request'
import {
  getPlanCoursePublish,
  publishStudentScore,
  getStudentScoreList,
  getOtsUrl,
  getExamCheckState,
  changeExamCheckState,
  exportStudentScore,
  changeCourseScoreSet,
  getCourseScoreSet,
  getPageList,
  scoreImport,
  getEnableScoreImport,
  importCheckStateFile,
  getCheckStateTemplate,
  getTrialScoreLinePlanList,
  getCourseList,
  getTrialScoreLineList,
  getPlan,
  getExamNumByCourse,
  getSubCourseList,
  getSubCourseStudentScoreList,
  exportSubCourseStudentScoreList,
  getStudentSubCourseList,
  applyList,
  applyExport,
  getReasonList,
  saveReason,
  getOrderFile,
  applySubmit,
  applyOrderInfo,
  uploadFile,
  applyCancel,
  auditNext,
  auditSubmit,
  auditCancel,
  updateReason,
  operationReason,
  getReasonCourseList,
  getReasonApplyList,
  uploadMaterial,
  getReasonMaterialList,
  saveReasonInfo,
  deleteReasonMaterialList,
  deleteReasonInfo,
  exportReasonInfo,
  importReasonInfo,
  downloadReasonInfo,
  exportSubCourseScore,
  synchronousExemptInfo,
  publishPreJudgeExempt,
  getTypeList,
  insertTypeName,
  updateTypeName,
  operationType,
  getPlanTypeList,
  operationPlanType,
  deletePlanType,
  getTypeSetList,
  operationTypeSet,
  getBatchTypeSetInfo,
  batchOperationTypeSet,
  getUserTypeScoreList,
  copySourcePlanTypeScore,
  deleteUserTypeScore,
  exportUserTypeScore,
  importUserTypeScore,
  saveUserTypeScore,
  getPlanPartInfo
} from '@/http/api'

export const getPlanPartInfoAPI = (data) => {
  return request({
    url: getPlanPartInfo,
    data,
  })
}

export const saveUserTypeScoreAPI = (data) => {
  return request({
    url: saveUserTypeScore,
    data,
  })
}

export const importUserTypeScoreAPI = (data) => {
  return request({
    url: importUserTypeScore,
    isUpload: true,
    data,
  })
}

export const exportUserTypeScoreAPI = (data) => {
  return request({
    url: exportUserTypeScore,
    data,
  })
}

export const deleteUserTypeScoreAPI = (data) => {
  return request({
    url: deleteUserTypeScore,
    data,
  })
}

export const copySourcePlanTypeScoreAPI = (data) => {
  return request({
    url: copySourcePlanTypeScore,
    data,
  })
}

export const getUserTypeScoreListAPI = (data) => {
  return request({
    url: getUserTypeScoreList,
    data,
  })
}

export const batchOperationTypeSetAPI = (data) => {
  return request({
    url: batchOperationTypeSet,
    data,
  })
}


export const getBatchTypeSetInfoAPI = (data) => {
  return request({
    url: getBatchTypeSetInfo,
    data,
  })
}

export const operationTypeSetAPI = (data) => {
  return request({
    url: operationTypeSet,
    data,
  })
}

export const getTypeSetListAPI = (data) => {
  return request({
    url: getTypeSetList,
    data,
  })
}

export const deletePlanTypeAPI = (data) => {
  return request({
    url: deletePlanType,
    data,
  })
}

export const operationPlanTypeAPI = (data) => {
  return request({
    url: operationPlanType,
    data,
  })
}

export const getPlanTypeListAPI = (data) => {
  return request({
    url: getPlanTypeList,
    data,
  })
}

export const operationTypeAPI = (data) => {
  return request({
    url: operationType,
    data,
  })
}

export const updateTypeNameAPI = (data) => {
  return request({
    url: updateTypeName,
    data,
  })
}

export const insertTypeNameAPI = (data) => {
  return request({
    url: insertTypeName,
    data,
  })
}

export const getTypeListAPI = (data) => {
  return request({
    url: getTypeList,
    data,
  })
}

export const publishPreJudgeExemptAPI = (data) => {
  return request({
    url: publishPreJudgeExempt,
    data,
  })
}

export const synchronousExemptInfoAPI = (data) => {
  return request({
    url: synchronousExemptInfo,
    data,
  })
}

export const exportSubCourseScoreAPI = (data) => {
  return request({
    url: exportSubCourseScore,
    data,
  })
}

export const downloadReasonInfoAPI = (data) => {
  return request({
    url: downloadReasonInfo,
    data,
  })
}

export const importReasonInfoAPI = (data) => {
  return request({
    url: importReasonInfo,
    isUpload: true,
    data,
  })
}

export const exportReasonInfoAPI = (data) => {
  return request({
    url: exportReasonInfo,
    data,
  })
}

export const deleteReasonInfoAPI = (data) => {
  return request({
    url: deleteReasonInfo,
    data,
  })
}

export const deleteReasonMaterialListAPI = (data) => {
  return request({
    url: deleteReasonMaterialList,
    data,
  })
}

export const saveReasonInfoAPI = (data) => {
  return request({
    url: saveReasonInfo,
    data,
  })
}

export const getReasonMaterialListAPI = (data) => {
  return request({
    url: getReasonMaterialList,
    data,
  })
}

export const uploadMaterialAPI = (data) => {
  return request({
    url: uploadMaterial,
    isUpload: true,
    data,
  })
}

export const getReasonApplyListAPI = (data) => {
  return request({
    url: getReasonApplyList,
    data,
  })
}

export const getReasonCourseListAPI = (data) => {
  return request({
    url: getReasonCourseList,
    data,
  })
}

export const operationReasonAPI = (data) => {
  return request({
    url: operationReason,
    data,
  })
}

export const updateReasonAPI = (data) => {
  return request({
    url: updateReason,
    data,
  })
}

export const auditCancelAPI = (data) => {
  return request({
    url: auditCancel,
    data,
  })
}

export const auditSubmitAPI = (data) => {
  return request({
    url: auditSubmit,
    data,
  })
}

export const auditNextAPI = (data) => {
  return request({
    url: auditNext,
    data,
  })
}

export const applyCancelAPI = (data) => {
  return request({
    url: applyCancel,
    data,
  })
}

export const uploadFileAPI = (data) => {
  return request({
    url: uploadFile,
    isUpload: true,
    data,
  })
}

export const applyOrderInfoAPI = (data) => {
  return request({
    url: applyOrderInfo,
    data,
  })
}

export const applySubmitAPI = (data) => {
  return request({
    url: applySubmit,
    data,
  })
}

export const getOrderFileAPI = (data) => {
  return request({
    url: getOrderFile,
    data,
  })
}

export const saveReasonAPI = (data) => {
  return request({
    url: saveReason,
    data,
  })
}

export const getReasonListAPI = (data) => {
  return request({
    url: getReasonList,
    data,
  })
}

export const applyExportAPI = (data) => {
  return request({
    url: applyExport,
    data,
  })
}

export const applyListAPI = (data) => {
  return request({
    url: applyList,
    data,
  })
}

export const getStudentSubCourseListAPI = (data) => {
  return request({
    url: getStudentSubCourseList,
    data,
  })
}

export const exportSubCourseStudentScoreListAPI = (data) => {
  return request({
    url: exportSubCourseStudentScoreList,
    data,
  })
}

export const getSubCourseStudentScoreListAPI = (data) => {
  return request({
    url: getSubCourseStudentScoreList,
    data,
  })
}

export const getSubCourseListAPI = (data) => {
  return request({
    url: getSubCourseList,
    data,
  })
}

export const getExamNumByCourseAPI = (data) => {
  return request({
    url: getExamNumByCourse,
    data,
  })
}

export const getPlanApi = (data) => {
  return request({
    url: getPlan,
    data,
  })
}

export const getTrialScoreLineListApi = (data) => {
  return request({
    url: getTrialScoreLineList,
    data,
  })
}

export const getCourseListApi = (data) => {
  return request({
    url: getCourseList,
    data,
  })
}

export const getTrialScoreLinePlanListApi = (data) => {
  return request({
    url: getTrialScoreLinePlanList,
    data,
  })
}

export const changeCourseScoreSets = (data) => {
  return request({
    url: changeCourseScoreSet,
    data,
  })
}
export const getCourseScore = (data) => {
  return request({
    url: getCourseScoreSet,
    data,
  })
}
export const getPlanCoursePublishFn = (data) => {
  return request({
    url: getPlanCoursePublish,
    data,
  })
}

export const publishStudentScoreFn = (data) => {
  return request({
    url: publishStudentScore,
    data,
  })
}

export const getPageListFn = (data) => {
  return request({
    url: getPageList,
    data,
  })
}
export const getStudentScoreListFn = (data) => {
  return request({
    url: getStudentScoreList,
    data,
  })
}
export const getOtsUrlFn = (data) => {
  return request({
    url: getOtsUrl,
    data,
  })
}

export const getExamCheckStateFn = () => {
  return request({
    url: getExamCheckState,
  })
}

export const changeExamCheckStateFn = (data) => {
  return request({
    url: changeExamCheckState,
    data,
  })
}

export const exportStudentScoreFn = (data) => {
  return request({
    url: exportStudentScore,
    data,
  })
}
export const dateAuditState = (data) => {
  return request({
    url: updateAuditState,
    data,
  })

}
export const scoreImportecxel = (data) => {
  return request({
    url: scoreImport,
    isUpload: true,
    data,
  })

}
export const getEnableScoreImportpland = (data) => {
  return request({
    url: getEnableScoreImport,
    data,
  })

}
export const importCheckStateFileexcel = (data) => {
  return request({
    url: importCheckStateFile,
    isUpload: true,
    data,
  })

}
export const getCheckStateTemplateexcel = (data) => {
  return request({
    url: getCheckStateTemplate,
    isUpload: true,
    data,
  })
}